(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-line-art-runtime"] && !Shopify.designMode) return;
  try {
    function cmLineArtQuote(count, policy) {
  const tier = [...policy.tiers].reverse().find(t => count >= t.minimum);
  const percent = tier?.percent || 0;
  const unitCents = Math.round(policy.baseCents * (100 - percent) / 100);
  const regularCents = count * policy.baseCents;
  const totalCents = count * unitCents;
  return { count, percent, unitCents, regularCents, totalCents, savingsCents: regularCents - totalCents, next: policy.tiers.find(t => count < t.minimum) || null };
}
(() => {
  if (window.cmLineArtReady) return;
  window.cmLineArtReady = true;
  const config = document.querySelector('[data-la-config]');
  if (!config) return;
  const words = JSON.parse(config.textContent);
  const policy = JSON.parse(document.querySelector('[data-la-pricing]').textContent);
  const money = cents => new Intl.NumberFormat('en-CA', { style: 'currency', currency: policy.currency }).format(cents / 100) + ' CAD';
  const format = (key, values) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{{ ' + name + ' }}', String(value)), words[key]);
  const selected = new Map();
  const storageKey = 'cm-line-art-selection-v1:' + location.pathname;
  let busy = false;
  let blocked = false;
  const root = window.Shopify?.routes?.root || '/';
  const message = (key, count) => words[key].replace('{{ count }}', String(count));
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) for (const item of saved.slice(0, 100)) {
      if (/^\d+$/.test(item.product) && /^\d+$/.test(item.variant)) selected.set(item.product, item);
    }
  } catch {}
  const persist = () => {
    try { sessionStorage.setItem(storageKey, JSON.stringify([...selected.values()])); } catch {}
  };
  const sync = () => {
    document.querySelectorAll('[data-la-control], [data-la-toolbar]').forEach(el => { el.hidden = false; });
    document.querySelectorAll('[data-la-select]').forEach(el => {
      el.checked = selected.has(el.dataset.product);
      el.disabled = busy || blocked;
      el.closest('li')?.classList.toggle('cm-design-selected', el.checked);
    });
    document.querySelectorAll('[data-la-count]').forEach(el => { el.textContent = message('count', selected.size); });
    const quote = cmLineArtQuote(selected.size, policy);
    document.querySelectorAll('[data-la-progress]').forEach(el => {
      el.textContent = quote.next
        ? format('unlock', { count: quote.next.minimum - selected.size, percent: quote.next.percent })
        : format('best', { percent: quote.percent });
    });
    document.querySelectorAll('[data-la-tiers]').forEach(el => {
      if (!el.children.length) for (const tier of policy.tiers) {
        const li = document.createElement('li');
        const label = document.createElement('strong');
        label.textContent = format('threshold', { count: tier.minimum });
        li.append(label, document.createElement('br'), document.createTextNode(format('off', { percent: tier.percent })));
        li.dataset.laTier = String(tier.minimum);
        el.append(li);
      }
      for (const li of el.children) {
        const active = quote.percent > 0 && Number(li.dataset.laTier) === [...policy.tiers].reverse().find(t => selected.size >= t.minimum)?.minimum;
        li.classList.toggle('cm-design-tier-active', active);
        if (active) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      }
    });
    document.querySelectorAll('[data-la-price-summary]').forEach(el => {
      el.hidden = false;
      const old = el.querySelector('[data-la-old]');
      old.hidden = quote.percent === 0;
      old.textContent = money(policy.baseCents);
      el.querySelector('[data-la-unit]').textContent = format('each', { price: money(quote.unitCents) });
      el.querySelector('[data-la-percent]').textContent = quote.percent ? format('off', { percent: quote.percent }) : '';
      el.querySelector('[data-la-regular]').textContent = money(quote.regularCents);
      el.querySelector('[data-la-savings]').textContent = money(quote.savingsCents);
      el.querySelector('[data-la-total]').textContent = money(quote.totalCents);
    });
    document.querySelectorAll('[data-la-select]').forEach(input => {
      const card = input.closest('li');
      const panel = card?.querySelector('[data-la-card-price]');
      const discounted = quote.percent > 0;
      card?.classList.toggle('cm-design-discounted', discounted);
      if (panel) {
        panel.hidden = false;
        panel.querySelector('[data-la-card-values]').hidden = !discounted;
        const hint = quote.next ? { count: quote.next.minimum - quote.count, percent: quote.next.percent } : { percent: quote.percent };
        panel.querySelector('[data-la-card-next]').textContent = format(quote.next ? 'card_next' : 'card_best', hint);
        panel.querySelector('[data-la-card-next-short]').textContent = format(quote.next ? 'card_next_short' : 'card_best', hint);
        panel.querySelector('s').textContent = money(policy.baseCents);
        panel.querySelector('strong').textContent = money(quote.unitCents);
        panel.querySelector('[data-la-card-percent]').textContent = format('off', { percent: quote.percent });
      }
    });
    document.querySelectorAll('[data-la-add]').forEach(el => {
      el.disabled = busy || blocked || !selected.size;
      el.textContent = busy ? words.busy : message('add', selected.size);
    });
    document.querySelectorAll('[data-la-clear]').forEach(el => { el.disabled = busy; });
  };
  const result = text => document.querySelectorAll('[data-la-result]').forEach(el => { el.textContent = text; });
  const request = async (path, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(root + path, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
      const json = await response.json();
      if (!response.ok) throw new Error('cart-request-failed');
      return json;
    } finally { clearTimeout(timer); }
  };
  const counts = cart => {
    const out = new Map();
    for (const item of cart.items || []) {
      const id = String(item.product_id);
      out.set(id, (out.get(id) || 0) + item.quantity);
    }
    return out;
  };
  const transact = async (items, report) => {
    if (busy || blocked) return false;
    busy = true;
    sync();
    report(words.busy);
    const remaining = new Map(items.map(item => [item.product, item]));
    try {
      let cart = await request('cart.js');
      let found = counts(cart);
      if (items.some(item => (found.get(item.product) || 0) > 1)) {
        report(words.conflict);
        return false;
      }
      const reconcile = () => {
        found = counts(cart);
        for (const [id] of remaining) if (found.get(id) === 1) {
          remaining.delete(id);
          selected.delete(id);
        }
        persist();
        sync();
      };
      reconcile();
      while (remaining.size) {
        const batch = [...remaining.values()].slice(0, 20);
        let failed = false;
        try {
          await request('cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: batch.map(item => ({ id: item.variant, quantity: 1 })) })
          });
        } catch { failed = true; }
        try { cart = await request('cart.js'); } catch {
          blocked = true;
          report(words.uncertain);
          return false;
        }
        reconcile();
        if (failed || batch.some(item => found.get(item.product) !== 1)) {
          if (failed) blocked = true;
          report(failed ? words.uncertain : words.error);
          return false;
        }
      }
      report(words.done);
      return true;
    } catch {
      report(words.error);
      return false;
    } finally {
      busy = false;
      sync();
    }
  };
  document.addEventListener('change', event => {
    const el = event.target.closest('[data-la-select]');
    if (!el) return;
    if (busy || blocked) { sync(); return; }
    if (el.checked && selected.size >= 100 && !selected.has(el.dataset.product)) {
      result(words.limit);
      sync();
      return;
    }
    if (el.checked) selected.set(el.dataset.product, { product: el.dataset.product, variant: el.dataset.variant });
    else selected.delete(el.dataset.product);
    persist();
    sync();
  });
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-la-clear]') && !busy) {
      selected.clear(); persist(); sync(); result(''); return;
    }
    if (!event.target.closest('[data-la-add]')) return;
    event.preventDefault();
    if (await transact([...selected.values()], result)) location.assign(root + 'cart');
  });
  document.addEventListener('submit', async event => {
    const marker = event.target.querySelector('[data-la-product]');
    if (!marker) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const status = event.target.querySelector('[data-la-product-result]');
    const item = { product: marker.dataset.laProduct, variant: marker.dataset.laVariant };
    if (await transact([item], text => { if (status) status.textContent = text; })) location.assign(root + 'cart');
  }, true);
  let queued = false;
  const observer = new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.('[data-la-control], [data-la-select]') || node.querySelector?.('[data-la-control], [data-la-select]'))
    ))) return;
    if (!queued) {
      queued = true;
      queueMicrotask(() => { queued = false; sync(); });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', sync);
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
